import React from 'react';

const OPERATION_LABELS = {
  policy_guide_draft: 'Drafting Assistant draft',
  policy_guide_check: 'Drafting Assistant conformance check',
  policy_guide_cite: 'Drafting Assistant citation scan',
  conflict_scan: 'conflict scan',
  consolidation: 'consolidation',
  type_evaluation: 'document type check',
  corpus_narrative: 'duplicate/reuse narrative',
  template_narrative: 'template conformance narrative',
  all: 'AI',
};

function formatWait(seconds) {
  if (seconds < 90) return `${seconds} second(s)`;
  const minutes = Math.round(seconds / 60);
  if (minutes < 90) return `${minutes} minute(s)`;
  const hours = Math.round(minutes / 60);
  return `${hours} hour(s)`;
}

/**
 * The primary, real-time signal for an AI usage quota refusal (GitHub issue
 * #159) -- a structured pop-up rather than leaving the caller to read the
 * plain-string banner every AI panel already renders from
 * extractErrorMessage(). Driven entirely by the `quota` field on a 429
 * (see utils/errors.js::quotaFromError), never re-derived client-side, so
 * this can never disagree with what the server actually enforced.
 *
 * The opt-in EMAIL copy of this (issue #159's other half) is a secondary
 * heads-up for someone not watching the screen -- see My Profile >
 * Notifications. This modal is not that; it needs no fetch and no opt-in,
 * since it is just reading the response the caller's own request received.
 */
function QuotaLimitModal({ quota, onClose }) {
  if (!quota) return null;
  const label = OPERATION_LABELS[quota.operation] || quota.operation;
  const resetsAt = quota.resets_at ? new Date(quota.resets_at) : null;

  return (
    <div className="modal-overlay">
      <div className="modal">
        <div className="modal-header">
          <h3>AI usage limit reached</h3>
        </div>
        <div style={{ padding: '0 1.5rem 1.5rem' }}>
          <p>
            You have used <strong>{quota.used}</strong> of <strong>{quota.limit}</strong>{' '}
            allowed {label} run(s) in the last {quota.window_hours} hour(s)
            {quota.scope === 'per_organization' ? ' across the whole organization' : ''}.
          </p>
          <p>
            Try again in about <strong>{formatWait(quota.retry_after_seconds)}</strong>
            {resetsAt && !Number.isNaN(resetsAt.getTime())
              ? ` (resets at ${resetsAt.toLocaleString()}).`
              : '.'}
          </p>
          <p style={{ color: 'var(--muted)' }}>
            An administrator can raise this limit under Admin → System Settings.
          </p>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-primary" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default QuotaLimitModal;
